exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Mam2_grid__10rys {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  grid-template-rows: 1fr 1fr;\n  grid-template-areas: 'main main main exp' 'main main main assets';\n  grid-gap: 1em;\n}\n\n.Mam2_main__hOS2D {\n  grid-area: main;\n  /* background-color: darkkhaki; */\n}\n\n.Mam2_exp__3cB3h {\n  grid-area: exp;\n  /* background-color: cadetblue; */\n}\n\n.Mam2_assets__3bvLZ {\n  grid-area: assets;\n  /* background-color: beige; */\n}\n", ""]);

// exports
exports.locals = {
	"grid": "Mam2_grid__10rys",
	"main": "Mam2_main__hOS2D",
	"exp": "Mam2_exp__3cB3h",
	"assets": "Mam2_assets__3bvLZ"
};